import { Pipe, PipeTransform } from "@angular/core";

export enum ClientSearchPlaceholder {
  RXWORKS = "enums.client_search_placeholder.rxworks",
  ROBOVET = "enums.client_search_placeholder.robovet",
  MERLIN = "enums.client_search_placeholder.merlin",
  TELEOS = "enums.client_search_placeholder.teleos",
  PROVET = "enums.client_search_placeholder.provet",
  EZYVET = "enums.client_search_placeholder.ezyvet",
  VETIT = "enums.client_search_placeholder.vetit",
  LUPA = "enums.client_search_placeholder.lupa"
}

// not allowed duplicated values
const enumToTranslation: Record<ClientSearchPlaceholder, string> = {
  [ClientSearchPlaceholder.EZYVET]: 'enums.client_search_placeholder.ezyvet',
  [ClientSearchPlaceholder.ROBOVET]: 'enums.client_search_placeholder.robovet',
  [ClientSearchPlaceholder.TELEOS]: 'enums.client_search_placeholder.teleos',
  [ClientSearchPlaceholder.VETIT]: 'enums.client_search_placeholder.vetit',
  [ClientSearchPlaceholder.RXWORKS]: 'enums.client_search_placeholder.rxworks',
  [ClientSearchPlaceholder.MERLIN]: 'enums.client_search_placeholder.merlin',
  [ClientSearchPlaceholder.PROVET]: 'enums.client_search_placeholder.provet',
  [ClientSearchPlaceholder.LUPA]: 'enums.client_search_placeholder.lupa'
}

@Pipe({name: 'clientSearchPlaceholderTranslationKey'})
export class ClientSearchPlaceholderTranslationKeyPipe implements PipeTransform {
  transform(value: ClientSearchPlaceholder): string {
    return enumToTranslation[value];
  }
}
